import React from 'react';

import { salesOrdersContainerConfiguration } from '@totem/components/salesOrders/list/containerConfiguration';
import SalesOrdersContainer from '@totem/components/salesOrders/list/SalesOrdersContainer';
import SalesOrdersLayout from '@totem/components/salesOrders/list/SalesOrdersLayout';
import InputContainer from '@totem/components/ui_components/reportSettings/InputContainer';

type Props = {
  salesOrderKey: string;
};

// Every line of one NetSuite sales order, identified by its internal id (the ticket's NETSUITE_SALES_ORDER_KEY).
const SalesOrderKeyLines = ({ salesOrderKey }: Props) => {
  return (
    <InputContainer
      filterConfig={salesOrdersContainerConfiguration}
      staticFilters={[{ field: 'nsSalesOrder.id', values: [salesOrderKey] }]}
      defaultSort={{ field: 'nsSalesOrderLine.line', direction: 'ascend' }}
    >
      <SalesOrdersContainer>
        <SalesOrdersLayout />
      </SalesOrdersContainer>
    </InputContainer>
  );
};

export default SalesOrderKeyLines;
